import React from 'react';
import { _ReactChildren } from '../../models/common.models';

interface IsRenderProps {
  isRender: boolean;
  children: _ReactChildren;
}

const IsRender = (props: IsRenderProps): React.ReactElement => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return props.isRender ? <>{props.children}</> : null;
};

export default IsRender;
